import React from "react";

import { ButtonGroup } from "devextreme-react/button-group";

import { useFxDispatch, useFxSelector } from "@app/statefx";
import { schema } from "@app/statefx/schema";
import { EUIIMainSOT } from "@app/statefx/schema/uiInvoiceMain.def";
import { sfxPreserveTrackState } from "@app/statefx/xThunks/uiInvoiceTree";
import "@app/style/dx.generic.catetory-chooser-compact.css";
import "@app/style/dx.generic.catetory-chooser.css";

import "./monthtrack.scss";

const gridPicker = [
  {
    grid: EUIIMainSOT.FACTURI_FISCALE_EMISE,
    icon: "ordersbox",
    text: "",
    hint: "Emitere, Gestionare, Incasare Facturi fiscale",
    visible: true,
    disabled: false,
  },
  {
    grid: EUIIMainSOT.SPV_OVERALL,
    icon: "message",
    text: "",
    hint: "Mesaje SPV",
    visible: true,
    disabled: false,
  },
];
export const TreeSwitch = () => {
  const dispatch = useFxDispatch();
  const uiInvoiceSettings = useFxSelector(schema.uiInvoiceOverall.select);
  const mainSOT = uiInvoiceSettings.mainSOT;
  const itemClick = (e: any) => {
    dispatch(sfxPreserveTrackState({ mainSOT: e.itemData.grid }));
  };
  return (
    <div id="invoiceTreeSwitch">
      <ButtonGroup
        items={gridPicker}
        keyExpr="grid"
        stylingMode="outlined"
        defaultSelectedItemKeys={[EUIIMainSOT.FACTURI_FISCALE_EMISE]}
        selectedItemKeys={[mainSOT]}
        onItemClick={itemClick}
        width={"100%"}
      />
    </div>
  );
};
